import { Link } from "react-router-dom";
import { FiArrowUpRight, FiShield } from "react-icons/fi";

const policies = [
  {
    title: "Code7s Privacy Policy",
    desc: "Privacy details for the Code7s website, studio services, client projects, and products published by Code7s.",
    link: "/privacy-policy/code7s",
  },
  {
    title: "Sudoku App Privacy Policy",
    desc: "Privacy details for the Sudoku app published by Code7s, including gameplay data, analytics, diagnostics, and children privacy.",
    link: "/privacy-policy/sudoku",
  },
];

export default function PrivacyPolicy() {
  return (
    <main className="premium-page">
      <section className="premium-shell">
        <div className="page-hero-block">
          <p className="eyebrow">Privacy Center</p>
          <h1 className="hero-heading mt-5">Privacy policies.</h1>
          <p className="hero-copy">
            Choose the policy you want to view. Code7s keeps studio, website,
            and app privacy information clear and easy to access.
          </p>
        </div>

        <div className="mx-auto mt-14 grid max-w-5xl gap-5 md:grid-cols-2">
          {policies.map((policy) => (
            <Link
              key={policy.title}
              to={policy.link}
              className="premium-card rounded-[26px] p-6 text-center"
            >
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-neutral-950 text-2xl text-white">
                <FiShield aria-hidden="true" />
              </div>
              <h2 className="mt-6 text-3xl font-extrabold tracking-tight text-neutral-950">
                {policy.title}
              </h2>
              <p className="section-copy mt-4">{policy.desc}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm font-bold">
                View policy <FiArrowUpRight aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}
